import { ClockingInScope, DocumentScope, UserExpenseScope, WorkReportScope } from '@/enums'
import { globalAuthGuard } from '@/guards'
import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'

import Home from '../views/Home.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    children: [
      {
        path: 'users',
        name: 'Users',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "users" */ '../views/Users.vue'),
        children: [
          {
            path: ':id',
            name: 'User',
            component: () => import('../views/User.vue')
          },
          { // TODO: REMOVE
            path: ':userId/clocking-ins',
            name: 'User Clocking Ins',
            props: { scope: ClockingInScope.user },
            component: () => import('../views/ClockingIns.vue')
          },
          {
            path: ':userId/work-reports',
            name: 'User Work Reports',
            props: { scope: WorkReportScope.user },
            component: () => import('../views/WorkReports.vue')
          },
          {
            path: ':userId/documents',
            name: 'User Documents',
            component: () => import('../views/UserDocuments.vue')
          },
          {
            path: ':userId/expenses',
            name: 'User expenses',
            props: { scope: UserExpenseScope.user },
            component: () => import('../views/UserExpenses.vue')
          }
        ]
      },
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('../views/Dashboard.vue'),
        children: [
          {
            path: 'communications/:id',
            name: 'Dashboard Comunication',
            component: () => import('../views/CompanyCommunication.vue')
          },
          {
            path: 'documents/:id',
            name: 'Dashboard Document',
            props: { scope: DocumentScope.companyDocument },
            component: () => import('../views/DocumentDetails.vue')
          },
          {
            path: 'archived/:id',
            name: 'Archived',
            component: () => import('../views/ArchivedDocumentDetails.vue')
          }
        ]
      },
      {
        path: 'orders',
        name: 'Orders',
        component: () => import('../views/Orders.vue'),
        children: [
          {
            path: ':orderId',
            name: 'Working sites',
            component: () => import('../views/WorkingSites.vue'),
            children: [
              {
                path: 'order-details',
                name: 'Order Details',
                component: () => import('../views/OrderDetails.vue')
              },
              {
                path: ':workingSiteId',
                name: 'Working site ',
                component: () => import('../views/WorkingSite.vue')
              }
            ]
          },
          {
            path: ':workingSiteId/clocking-ins',
            name: 'Working site clocking ins',
            props: { scope: ClockingInScope.workingSite },
            component: () => import('../views/ClockingIns.vue')
          }
        ]
      },
      {
        path: 'notifications',
        name: 'Notifications',
        component: () => import('../views/Notifications.vue'),
        children: [
          {
            path: ':id',
            name: 'Notification',
            component: () => import('../views/Notification.vue')
          }
        ]
      },
      {
        path: 'reports',
        name: 'Reports',
        component: () => import('../views/Reports.vue')
      },
      { path: '', redirect: 'users' }
    ]
  },
  {
    path: '/auth/login',
    name: 'Login',
    component: () => import('../views/Login.vue')
  },
  { path: '/:catchAll(.*)', redirect: '/auth/login', name: 'NotFound' }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach(globalAuthGuard)

export default router
